import { render, staticRenderFns } from "./AssignMyContent.vue?vue&type=template&id=58a2586b&"
import script from "./AssignMyContent.vue?vue&type=script&lang=js&"
export * from "./AssignMyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports